export const EVENT_HANDLERS = {
    AIBox_FileProcessed : "AIBox_FileProcessed"
}
